import { cn } from '@/components/ui';
import { textSizes, typeRoles } from '../tokens';
import { Code, Section, SubTitle } from './Section';

const SAMPLE = 'Съешь же ещё этих мягких французских булок, да выпей чаю';

export function TypographySection() {
  return (
    <Section
      id="type"
      title="Типографика"
      lead="Inter Variable поставляется с приложением. Роли type-* задают размер, интерлиньяж, вес, трекинг и регистр — цвет назначается отдельно (R14). Прямые размеры — только когда роль не подходит; 10 и 13 px в системе не существуют."
    >
      <div className="flex flex-col gap-3">
        <SubTitle>Роли</SubTitle>
        <div className="flex flex-col divide-y divide-line rounded-lg border border-line bg-card">
          {typeRoles.map((r) => (
            <div
              key={r.utility}
              className="grid grid-cols-1 items-baseline gap-2 px-5 py-4 md:grid-cols-[12rem_1fr_14rem]"
            >
              <div className="flex flex-col gap-1">
                <Code>{r.utility}</Code>
                <span className="text-2xs text-fg-subtle">{r.spec}</span>
              </div>
              <div className={cn(r.utility, 'text-fg')}>
                {r.utility === 'type-display' ? '24 333' : SAMPLE}
              </div>
              <div className="text-xs text-fg-muted">{r.usage}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <SubTitle>Шкала размеров</SubTitle>
        <div className="flex flex-col divide-y divide-line rounded-lg border border-line bg-card">
          {textSizes.map((s) => (
            <div key={s} className="grid grid-cols-[8rem_1fr] items-baseline gap-4 px-5 py-3">
              <Code>{s}</Code>
              <div className={cn(s, 'text-fg')}>Платформа X — {s}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <SubTitle>Моноширинный</SubTitle>
        <pre className="overflow-x-auto rounded-lg border border-line bg-muted p-4 font-mono text-xs text-fg">
          {'host-338  198.51.100.12  PVE 8.2  uptime 41d  load 0.42 0.38 0.35'}
        </pre>
      </div>
    </Section>
  );
}
